import { MutableRefObject } from "react"
import { NextRouter } from "next/router"
import { ECommerceService } from "../machines/ecommerce-machine/e-commerce-machine"
import { useSyncUrlOnStateChange } from "./use-sync-url-on-state-change"
import { useSyncStateOnHistoryNavigationV3 } from "./use-sync-state-on-history-navigation-v3"

export const useSyncStateWithUrlV3 = (
    isRestoreComplete: MutableRefObject<boolean>,
    router: NextRouter,
    ecommerce: ECommerceService,
) => {
    useSyncUrlOnStateChange(isRestoreComplete, router, ecommerce)
    useSyncStateOnHistoryNavigationV3(isRestoreComplete, router, ecommerce)
}
